
IREP.jana = (function () {
    "use strict";

    var init = function () {
        $("#link").click(function(event) {
            event.preventDefault();

            var options = {
                url: "jana/sendcode",
                data: { CampaignId: 4 },
                type: "GET"
            };

            IREP.callApi(options).done(function(data) {
                if (data.success) {
                    $("#preRedemption").hide();
                    $("#postRedemption").show();
                }
            });
        });
    };

    return {
        init: init
    };
})();